var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppointmentMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#545B7D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7335 13.6309L11.5513 17.7383C11.1959 18.0872 10.6219 18.0872 10.2665 17.7383C9.91116 17.3893 9.91116 16.8255 10.2665 16.4765L13.8018 12.9955L10.2665 9.52349C9.91116 9.1745 9.91116 8.61074 10.2665 8.26175C10.6219 7.91275 11.1959 7.91275 11.5513 8.26175L15.7335 12.3691C16.0888 12.7092 16.0888 13.2819 15.7335 13.6309Z",
    fill: "#545B7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentMore);
export default __webpack_public_path__ + "static/media/AppointmentMore.9699bd97.svg";
export { ForwardRef as ReactComponent };